import makeStyles from '@mui/styles/makeStyles';
import { alpha, lighten } from '@mui/material/styles';

export const useStyles = makeStyles((theme) => ({
  title: {
    justifyContent: 'center',
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  dialogContent: {
    height: '100%',
    overflowY: 'auto',
  },
  dateRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  ratingRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  col: {
    display: 'flex',
    flexDirection: (p) => (p.isMobile ? 'row' : 'column'),
    flex: '1 1 auto',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  ratingWrap: {
    display: 'flex',
    flexDirection: (p) => (p.isMobile ? 'column' : 'row'),
    width: '100%',
  },
  colMobile: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    height: '100%',
    width: 100,
    maxWidth: 20,
    minHeight: 30,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  textCol: {
    padding: theme.spacing(1),
  },
  textSmall: {
    fontSize: 12,
  },
  cpRow: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    pageBreakInside: 'avoid !important',
  },
  cpName: {
    width: (p) => (p.isMobile ? 100 : `calc(160px - ${theme.spacing(2)})`),
    minWidth: (p) => (p.isMobile ? 100 : `calc(160px - ${theme.spacing(2)})`),
    fontWeight: 600,
    fontSize: 12,
    display: 'flex',
    flexDirection: 'column',
  },
  cp_0: {
    backgroundColor: theme.palette.action.disabledBackground,
  },
  cp_1: {},
  hlRow: {
    backgroundColor: alpha(theme.colors.danger, 0.15),
  },
  cancelButton: {
    backgroundColor: theme.colors.red,
    '&:hover': {
      backgroundColor: lighten(theme.colors.red, 0.1),
    },
  },

  translationContainer: {
    padding: theme.spacing(0.5),
  },
  paddingTop: {
    paddingTop: theme.spacing(2),
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
